import "bootstrap/dist/css/bootstrap.min.css"; // already handled probably
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // add this line
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";
import "./tablet.css";
import "./mobile.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
		<HelmetProvider>
			<App />
		</HelmetProvider>
);
